import { Badge } from "@radix-ui/themes";
import { type CSSProperties } from "react";

interface SvgProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
}

export const LogoMark = ({ width, height, className, style }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 361 369.49"
    width={width}
    height={height}
    className={className}
    style={style}
  >
    <path
      fill="currentColor"
      d="M361,184.74c0,102.03-69.48,185.54-180.5,184.74C80.82,368.77,0,286.77,0,184.74S80.8.12,180.5,0c112.58-.14,180.5,82.71,180.5,184.74Z"
    />
    <path
      fill="#fff"
      d="M202.78,61.61c-23.19.03-44.47,8.34-61.14,22.2-.18-4.1-.29-7.99-.29-9.7,0-7.26-.31-8.04-3.42-8.66-1.82-.36-2.14-.51-16.16-.36-.49,0-.99,0-1.47.03l-26.57.35v124.32l-.16,124.33h72.16v-62.44c11.42,4.85,23.94,7.58,37.06,7.67,59.58.43,96.88-44.26,96.88-98.87s-36.46-98.94-96.88-98.87h0ZM202.95,204.02c-23.44-.16-42.43-19.45-42.43-43.43s19-43.41,42.43-43.44c26.47-.03,42.44,19.45,42.44,43.44s-16.33,43.62-42.44,43.43Z"
    />
  </svg>
);

export const LogoWordmark = ({ width, height, className, style }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1079.14 286.97"
    width={width}
    height={height}
    className={className}
    style={style}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M936.35,112.11c-7.09-14.95-23.39-26.38-43.48-30.51-12.52-2.56-32.03-2.56-44.22,0-21.29,4.49-42.84,14.86-41.5,19.97,1.02,3.93,15.3,25,16.95,25.02.96.02,3.92-1.31,6.58-2.95,19.72-12.13,46.95-12.43,60.86-.66,4.79,4.05,7.33,10.14,7.33,17.56,0,5.59-.2,6.22-1.75,5.61-.96-.38-6.03-1.88-11.25-3.34-8.49-2.38-11.15-2.65-25-2.58-17.41.08-25.97,1.79-37.6,7.51-24.45,12.04-34.88,40.44-23.58,64.21,5.71,12.02,16.07,20.56,30.68,25.32,10.92,3.55,30.54,4.42,42.13,1.87,9.1-2,19.71-6.71,26.87-11.91l5-3.63,1,13.36,18.75,1h19.02v-52.37c-.27-57.82-.48-60.18-6.79-73.49h0ZM898.76,192.3c-5.59,13.34-24.9,20.45-39.11,17.05-11.55-2.49-20.75-10.78-19-22.06,1.93-10.89,12.78-16.9,23.79-18.6,7.65-1.22,16-.63,22.47,1.88l.18.07c9.43,3.38,15.91,12.11,11.67,21.66h0Z"
    />
    <polygon
      fill="currentColor"
      fillRule="evenodd"
      points="665.38 83.05 644.39 83.97 635.14 83.97 635.14 83.25 665.38 83.05"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M786.9,228.02c-2.01,3.06-14.06,8.9-22.46,10.88-9.26,2.18-24.75,1.99-34.17-.42-18.19-4.65-29.63-15.25-36.04-33.4l-2.77-7.84-.32-39.33-1-39.22-13.11-.72h-9.89v.72l-22.75.28h-22.25v31.99c0,35.52.57,39.97,5.73,44.89,5.76,5.5,14.74,6.39,22.85,2.28,7.78-3.94,7.9-3.87,13.79,8.75,7.29,15.62,7.94,17.4,7.28,19.98-.74,2.88-7.05,6.78-16.65,10.31-9.82,3.61-28.87,4.61-39.04,2.06-21.24-5.33-35.06-19.4-39.46-40.19-1.13-5.34-1.47-15.25-1.48-43.63l-.02-36.38-13.5-.28-13.5-.29v-35.66l13.5-.29,13.5-.28v-22.42c0-12.07.33-21.98.73-22.02.4-.03,9.53-1.08,20.27-2.32v-.3s20.87-2.36,21.32-2.43,1.69.34,2.75.91c1.83.98,1.93,2.33,1.93,24.98v25.34h22.25l20.99-.92h1.76s9.78-.08,9.78-.08l13.22-.28v-22.45c0-12.49.34-22.73.76-22.77.41-.04,10.07-1.12,21.46-2.41h.02c11.4-1.29,20.96-2.4,21.28-2.46.31-.06,1.33.46,2.26,1.15,1.49,1.11,1.73,4.12,1.96,25l.26,23.38,22.5.55c12.37.3,22.62.64,22.77.75.15.11.15,7.96,0,17.45l-.27,17.25-45,1v67.19l2.48,4.91c3.33,6.59,6.55,8.76,13.77,9.29,4.84.35,6.91-.06,12.03-2.35,4.4-1.98,6.61-2.51,7.7-1.82.83.52,4.4,7.33,7.94,15.1,6.16,13.58,6.36,14.26,4.84,16.57Z"
    />
    <polygon
      fill="currentColor"
      fillRule="evenodd"
      points="667.14 82.97 667.14 83.04 665.38 83.05 667.14 82.97"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M456.29,81.06c-8.21,1.99-18.99,7.91-25.71,14.13-3.14,2.91-5.97,5.28-6.28,5.28s-.71-3.94-.87-8.75l-.29-8.75h-39v154h46l.5-48.5c.5-48.09.52-48.54,2.82-53.17,3.38-6.8,9.97-12.39,16.97-14.41,11.45-3.3,25.11.31,31.21,8.24s5.95,6.56,6.5,59.34l.5,48.5h47.5v-52c0-51.33-.03-52.1-2.31-59.96-3.44-11.87-7.65-19.06-16.16-27.57-8.66-8.66-16.33-13.1-27.63-15.99-9.21-2.36-24.89-2.54-33.76-.39h.01Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M329.14.5c-13.05,3.41-22.5,15.43-22.5,28.63,0,7.99,2.7,14.26,8.82,20.53,4.64,4.75,6.76,6.12,11.6,7.51,19.45,5.6,38.02-8.1,38.02-28.04,0-15.66-11.69-28.09-27.33-29.06-3.09-.19-6.96,0-8.61.44h0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M313.64,84.97c-.3,1.14-.5,77.16-.5,77.16l.27,74.84h46.73V82.97l-22.73,1h-23.23l-.55,1h0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M253.98,81.69c-8.43,2.69-14.56,6.63-21.58,13.85l-6.26,6.44v-9.09c0-8.59-.12-9.12-2.25-9.64-1.24-.3-10.13-.43-19.78-.27h-17.97v155h47l.03-40.3c.03-42.64.66-52.07,4.01-59.64,2.74-6.22,9.09-12.56,15.39-15.37,6.4-2.85,20.81-3.12,26.98-.5,2.61,1.11,4.41,1.33,5.58.7,2.14-1.15,11.52-32.29,10.7-35.56-1.59-6.35-28.34-9.93-41.86-5.62h.02Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1003.64,35.52c-11,1.27-20.34,2.34-20.75,2.38s-.75,10.19-.75,22.57v22.5h-12.35c-6.8.02-12.93.39-13.64.84-.98.62-1.21,4.86-1.01,17.73l.28,16.93,13.36.28,13.36.28.02,36.38c.01,28.38.35,38.29,1.48,43.63,4.4,20.79,18.22,34.86,39.46,40.19,10.16,2.55,29.22,1.55,39.04-2.05,10.56-3.87,17-8.11,17-11.19s-10.75-27.39-13.09-29.48c-1.68-1.51-2.22-1.42-7.5,1.25-12.48,6.29-24.45,2.21-27.93-9.52-1.17-3.94-1.48-11.7-1.48-37.29v-31.98h45v-36h-45v-23.97c0-22.67-.1-24.02-1.93-25-1.07-.57-2.31-.98-2.75-.91-.45.07-9.82,1.16-20.82,2.43h0Z"
    />
    <path
      fill="currentColor"
      d="M89.14,79.08c-18.77.02-36,6.86-49.49,18.28-.15-3.38-.24-6.58-.24-7.98,0-5.97-.26-6.62-2.76-7.13-1.48-.3-1.74-.42-13.09-.29-.39,0-.8,0-1.19.02l-22.23.28v102.36l-.14,102.36h59.14v-51.41c9.24,4,19.38,6.24,30,6.31,48.22.35,78.41-36.44,78.41-81.4s-29.51-81.47-78.41-81.4h0ZM89.52,196.46c-19.26-.14-34.88-15.99-34.88-35.7s15.61-35.68,34.88-35.7c21.76-.02,34.88,15.98,34.88,35.7s-13.43,35.85-34.88,35.7Z"
    />
  </svg>
);

export interface LogoProps {
  label?: string;
  className?: string;
}

export const Logo = ({ label, className }: LogoProps) => {
  return (
    <div className={className} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <LogoMark style={{ width: "1.3rem", height: "auto", color: "#517bd0" }} />
      <LogoWordmark style={{ height: "16px", marginLeft: "0.375rem", width: "auto" }} />
      {label && (
        <Badge radius="full" variant="soft" color="gray" size="1" style={{ marginLeft: "0.375rem", marginTop: "1px", transform: "scale(0.75)", fontWeight: 500 }}>
          {label}
        </Badge>
      )}
    </div>
  );
};
